// ⚠️ 此文件由 api:gen 自动生成，请勿手动修改
// 源: capabilities/form.yaml
// 生成时间: 2026-09-10T01:14:10.000Z
import http from '../http';

export default {
  // 获取列表 form.list
  list: (data) => http.post('formbuilder/applyform/page', data),

  // 获取单个表单信息 form.get
  get: (params) => http.get('formbuilder/applyform/get/' + params),

  // 保存或者更新表单信息 form.save
  save: (data) => http.post('formbuilder/applyform/save', data),

  // 更新状态 form.updateStatus
  updateStatus: (params) => http.post('formbuilder/applyform/update/status?id=' + params.id + '&status=' + params.status),

  // 复制/克隆表单 form.copy
  copy: (data) => http.post('formbuilder/applyform/copy', data),

  // 获取报表的头部 form.header
  header: (params) => http.post('formbuilder/applyform/head?form_id=' + params.id),

  // 删除表单 form.delete
  delete: (params) => http.post('formbuilder/applyform/remove?id=' + params),

  collect: {
    // 表单收集信息分页列表（与 getReportPages 为同一后端接口 /applyform/submit/page/list，本能力为 submit 子域统一命名） form.collect.list
    list: (data) => http.post('formbuilder/applyform/submit/page/list', data),

    // 同步CRM的表单收集信息汇总列表（管理员线索列表，对应前端 getSubmitClueList）。支持按CRM线索ID/呼叫中心/有效时间/跟进时间/提交时间/跟进状态/线索状态/是否老客户/是否有效/有效商机/分派组织/渠道/位置等条件组合查询，并支持表格列排序。 form.collect.listLead
    listLead: (data) => http.post('formbuilder/applyFormSubmit/page', data),

    // 表单模板 form.collect.importTemplate
    importTemplate: (params) => http.post('formbuilder/applyFormSubmit/export/template?formId=' + params.id),

    // 导入数据 form.collect.import
    import: (data) => http.post('formbuilder/applyFormSubmit/import/sumbit', data),

    // 获取单条表单提交记录完整详情（实体全量回传模式的读取端，供 submit.save 修改后整体回传） form.collect.get
    get: (params) => http.post('formbuilder/applyFormSubmit/get?id=' + params.id),

    // 保存/更新表单收集信息（实体全量回传模式，管理员编辑场景 manager/save）。必须先调 submit.get 获取完整提交记录对象，在其基础上仅修改目标字段，其余字段（含 IR 未枚举的系统字段，如 sem_*、cc*、zhaoBiao*、popularize_* 等归因/转存字段）原样回传后整体 POST；缺失字段会被后端覆盖/清空，勿自行裁剪对象。 form.collect.save
    save: (data) => http.post('formbuilder/applyFormSubmit/manager/save', data),
  },

  merge: {
    // 合并表单列表 form.merge.list
    list: (data) => http.post('formbuilder/statistics/list', data),

    // 合并表单 form.merge.save
    save: (data) => http.post('formbuilder/statistics/save', data),

    // 下载列表 form.merge.export
    export: (data) => http.post('formbuilder/statistics/export', data),

    // 表单合并数据统计 form.merge.get
    get: (data) => http.post('formbuilder/statistics/get', data),
  },

  field: {
    // 字段列表 form.field.list
    list: (data) => http.get('content-service/field/list', data),

    // 保存字段 form.field.save
    save: (data) => http.post('content-service/field/save', data),

    // 删除字段 form.field.delete
    delete: (data) => http.get('content-service/field/delete', data),
  },
};
